import React from "react";
import classes from "./NotAddedEmptyView.scss";
import classNames from "classnames";
import { useI18n } from "Hooks";

const NotAddedEmptyView = ({ emptyText, inputStyle, dsVersion }) => {
  const isDSV2 = dsVersion === "2.0";
  const { t } = useI18n(["common"]);

  const containerClass = classNames(classes.container, {
    [classes.containerV2]: isDSV2,
  });

  const emptyTextStyle = classNames({
    [classes.emptyText]: true,
    "text-body-1": !isDSV2,
    "text-body": isDSV2,
    [classes.emptyTextV2]: isDSV2,
  });

  const innerContainerClasses = classNames({
    [classes.innerContainer]: true,
    [classes.innerContainerV2]: isDSV2,
  });
  return (
    <div className={containerClass}>
      <div className={innerContainerClasses}>
        <div className={emptyTextStyle} style={{ ...inputStyle }}>
          {emptyText ? emptyText : t("common:not_added_yet")}
        </div>
      </div>
    </div>
  );
};

export default NotAddedEmptyView;
